var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkilldar1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: "233px",
    height: "306px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -38 -108 )"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 38.5 108.5  L 270.5 108.5  L 270.5 413.5  L 38.5 413.5  L 38.5 108.5  Z ",
    fillRule: "nonzero",
    fill: "#f2f2f2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.5 108.5  L 270.5 108.5  L 270.5 413.5  L 38.5 413.5  L 38.5 108.5  Z ",
    strokeWidth: 1,
    stroke: "#797979",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.397805370408754 108.52243967100891  L 270.6021946295913 413.4775603289911  M 270.6021946295913 108.52243967100891  L 38.397805370408754 413.4775603289911  ",
    strokeWidth: 1,
    stroke: "#797979",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkilldar1);
export default __webpack_public_path__ + "static/media/skilldar1.c418d9bf4261473b81498ec8629c6254.svg";
export { ForwardRef as ReactComponent };